import { authFetch } from "../helpers/FetchHelpers";
const { default: DataService } = require("./DataService");

// Mock data kept for reference only — replaced by the real API calls below.
// const MOCK_MEMBERS = [
//     { Id: 1, Name: "Siti Rahayu", Phone: "0812-3456-7890", Points: 8450, Tier: "Platinum", TotalTransactions: 132, JoinDate: "2023-02-14" },
//     { Id: 2, Name: "Budi Santoso", Phone: "0813-2345-6789", Points: 7120, Tier: "Platinum", TotalTransactions: 118, JoinDate: "2022-11-02" },
//     { Id: 3, Name: "Dewi Lestari", Phone: "0857-1122-3344", Points: 6980, Tier: "Platinum", TotalTransactions: 109, JoinDate: "2023-05-20" },
//     { Id: 4, Name: "Agus Setiawan", Phone: "0821-9988-7766", Points: 4310, Tier: "Gold", TotalTransactions: 76, JoinDate: "2023-08-09" },
//     { Id: 5, Name: "Rina Wulandari", Phone: "0878-4455-6677", Points: 3870, Tier: "Gold", TotalTransactions: 68, JoinDate: "2024-01-11" },
//     { Id: 6, Name: "Hendra Gunawan", Phone: "0812-6677-8899", Points: 2990, Tier: "Gold", TotalTransactions: 54, JoinDate: "2023-12-03" },
//     { Id: 7, Name: "Maya Sari", Phone: "0813-5566-7788", Points: 1820, Tier: "Silver", TotalTransactions: 39, JoinDate: "2024-03-18" },
//     { Id: 8, Name: "Fajar Nugroho", Phone: "0857-3344-5566", Points: 1540, Tier: "Silver", TotalTransactions: 31, JoinDate: "2024-04-25" },
//     { Id: 9, Name: "Putri Handayani", Phone: "0821-7788-9900", Points: 1205, Tier: "Silver", TotalTransactions: 27, JoinDate: "2024-06-07" },
//     { Id: 10, Name: "Yusuf Ramadhan", Phone: "0878-1122-3344", Points: 640, Tier: "Bronze", TotalTransactions: 15, JoinDate: "2024-09-14" },
//     { Id: 11, Name: "Lina Marlina", Phone: "0812-4433-2211", Points: 410, Tier: "Bronze", TotalTransactions: 9, JoinDate: "2025-01-22" },
//     { Id: 12, Name: "Rudi Hartono", Phone: "0813-9900-8877", Points: 180, Tier: "Bronze", TotalTransactions: 4, JoinDate: "2025-05-30" },
// ];

class LoyaltyDataService extends DataService {
    constructor() {
        super("loyalty")
    }

    getLoyaltyList(page, perPage, keyword) {
        keyword = typeof keyword !== 'undefined' ? keyword : '';

        let url = process.env.REACT_APP_API_URL + '/loyalty/list?page=' + page + '&per_page=' + perPage;
        if (keyword) {
            url += '&keyword=' + encodeURIComponent(keyword);
        }

        return authFetch(url, 'GET', null)
            .then((data) => {
                const list = data.data?.list;
                const total = data.data?.total;

                return {
                    loyaltyMembers: list ? list.map((member) => ({
                        Id: member.id,
                        Name: member.name,
                        Tier: member.tier,
                        Points: member.points,
                        TotalTransactions: member.totalTransactions,
                        JoinDate: member.joinDate,
                    })) : undefined,
                    totalPages: total !== undefined ? (total < perPage ? 1 : Math.ceil(total / perPage)) : undefined,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            });
    }

    getTopLoyaltyMembers() {
        return authFetch(process.env.REACT_APP_API_URL + '/loyalty/top', 'GET', null)
            .then((data) => {
                const top = data.data;

                return {
                    topLoyaltyMembers: Array.isArray(top) ? top.map((member) => ({
                        Id: member.id,
                        Name: member.name,
                        Points: member.points,
                    })) : undefined,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            });
    }
}

export default LoyaltyDataService;
